import { createContext, useContext } from 'react';
import { normalizeTemperatureUnit } from './temperature';

export const TemperatureUnitContext = createContext('fahrenheit');

export function useTemperatureUnit() {
  return normalizeTemperatureUnit(useContext(TemperatureUnitContext));
}
